import { render, staticRenderFns } from "./EventRegistryCommandsWidget.vue?vue&type=template&id=63b55ec8&"
import script from "./EventRegistryCommandsWidget.vue?vue&type=script&lang=js&"
export * from "./EventRegistryCommandsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports